<template>
  <div class="p-6">
    <div class="flex bg-white rounded-lg border border-slate-200">
      <div class="h-full">
        <ImportSourceTypeMenu />
      </div>
      <div class="flex-1 w-full border-l">
        <SearchesList />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import ImportSourceTypeMenu from './SourcesList/ImportSourceTypeMenu.vue'
import SearchesList from './SearchesList/SearchesList.vue'
</script>
<style>
.flash-enter-active {
  animation: flash-background 3s;
}

@keyframes flash-background {
  0% {
    background-color: transparent;
  }

  50% {
    background: var(--color-green-100);
  }

  100% {
    background-color: transparent;
  }
}

.flash-leave-active {
  animation: fade-out-background 0.2s;
}

@keyframes fade-out-background {
  100% {
    opacity: 0;
  }
}
</style>
